import axios from 'axios';
// axios.defaults.baseURL = 'http://localhost:32768'
axios.defaults.baseURL = '/api'
axios.defaults.withCredentials = true
export default axios